import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/outline";

import { PageContainer } from "../components/ui";
import WorkDetail from "../components/bundel/WorkDetail";

// Full-page work detail — used for direct links / refresh. In-app navigation
// from a card opens WorkDetail in a modal instead (see App.js).
const WorkPage = () => {
  const { grid } = useParams();
  const navigate = useNavigate();

  return (
    <PageContainer>
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="mb-4 inline-flex items-center gap-1.5 text-sm font-medium text-fairblue-500 hover:text-fairblue-700 focus:outline-none"
      >
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" />
        Back
      </button>
      <WorkDetail grid={grid} />
    </PageContainer>
  );
};

export default WorkPage;
